import React, { useEffect, useState } from "react";
import { fetchContent } from "../../services/api";
import { updateContent, extractErrorMessage } from "../../services/adminApi";
import { DEFAULT_CONTENT } from "../../data/contentDefaults";
import { TextField, TextAreaField, SaveBar } from "../FormControls";

const DataTextEditor = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [savedAt, setSavedAt] = useState(null);

    useEffect(() => {
        fetchContent()
            .then((content) => setData(content?.data || DEFAULT_CONTENT.data))
            .catch(() => setData(DEFAULT_CONTENT.data))
            .finally(() => setLoading(false));
    }, []);

    const patch = (fields) => {
        setData((prev) => ({ ...prev, ...fields }));
        setSavedAt(null);
    };

    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const saved = await updateContent("data", data);
            setData(saved);
            setSavedAt(Date.now());
        } catch (err) {
            setError(extractErrorMessage(err, "Не удалось сохранить"));
        } finally {
            setSaving(false);
        }
    };

    if (loading || !data) return <p>Загрузка…</p>;

    return (
        <div className="admin-section">
            <h2 className="admin-section-title">Данные — текст страницы</h2>

            <TextField
                label="Заголовок"
                value={data.heading}
                onChange={(v) => patch({ heading: v })}
            />
            <TextAreaField
                label="Подзаголовок"
                value={data.subheading}
                onChange={(v) => patch({ subheading: v })}
                rows={2}
            />
            <TextField
                label="Заголовок карточки «Наборы данных»"
                value={data.sourcesTitle}
                onChange={(v) => patch({ sourcesTitle: v })}
            />

            <p className="admin-hint">
                Сам список источников редактируется на вкладке «Данные —
                наборы».
            </p>

            <SaveBar
                onSave={handleSave}
                saving={saving}
                savedAt={savedAt}
                error={error}
            />
        </div>
    );
};

export default DataTextEditor;
